import React, { useState, useRef} from "react";
import { signUpUser } from "./signUpUser";
import { signInUser } from "./signInUser";
import { TERMS_OF_SERVICE, PRIVACY_POLICY } from "./terms"; // 약관 내용 불러오기



const AuthModal = ({ isOpen, onClose, onLoginSuccess}) => {
    const [isLogin, setIsLogin] = useState(true);
    const [formData, setFormData] = useState({
        password: "",
        email: "",
        phone: "",
        name: "",
    });
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [termsScrolled, setTermsScrolled] = useState(false);
    const [privacyScrolled, setPrivacyScrolled] = useState(false);
    const termsRef = useRef(null);
    const privacyRef = useRef(null);
    const formatPhoneNumber = (phone) => {
              // 숫자만 남기고 공백/하이픈 제거
              let cleaned = phone.replace(/\D/g, "");

              // 한국 전화번호 처리 (+82 국가 코드 추가)
              if (cleaned.startsWith("0")) {
                  cleaned = "+82" + cleaned.substring(1);
              } else if (!cleaned.startsWith("+")) {
                  cleaned = "+" + cleaned; // 국제 번호 형식이 아닐 경우 자동 변환
              }

              return cleaned;
          };

    const [showPassword, setShowPassword] = useState(false); // 비밀번호 가시성 상태 추가
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    


    


    if (!isOpen) return null;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleAuthToggle = () => {
        setIsLogin(!isLogin);
        setError("");
        setSuccessMessage("");
    };

    const handleSignUp = () => {
        if (!termsAccepted || !privacyAccepted) {
            setError("이용약관 및 개인정보 수집에 모두 동의해야 합니다.");
            return;
        }

        const { password, email, phone, name } = formData;

        signUpUser(password, email, phone, name, (err, result) => {
            if (err) {
                setError(err);
            } else {
                setSuccessMessage(result);

                setTimeout(() => {
                    if (onLoginSuccess) {
                        onLoginSuccess();  // ✅ 로그인 성공 시에만 실행!
                    }

                    onClose(); // 회원가입 성공 시 모달 닫기
                }, 1000); // 메시지를 잠깐 보여주고 닫기 (1초 후)
            }
        });
    };


    const handleSignIn = async () => {
        const { email, password } = formData;

        try {
            const { success, accessToken, error } = await signInUser(email, password); // ✅ Promise 처리

            if (success) {
                setSuccessMessage("로그인 성공!");
                console.log("✅ 로그인 성공! accessToken:");

                setTimeout(() => {
                  if (onLoginSuccess) {
                      onLoginSuccess();  // ✅ 로그인 성공 시 검색창 활성화!
                  }
                  if (onClose) {
                      onClose();  // ✅ 로그인 성공 후 모달 닫기
                  }

                }, 1000); 
            } else {
                setError(error); // ❌ 로그인 실패 시 에러 메시지 표시
            }
        } catch (err) {
            setError("로그인 중 오류가 발생했습니다.");
            console.error("⛔ 로그인 중 오류:", err);
        }
    };

    const handleTermsScroll = () => {
        if (termsRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = termsRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                setTermsScrolled(true);
            }
        }
    };

    // if (formData.password !== formData.confirmPassword) {
    //     setError("비밀번호가 일치하지 않습니다.");
    //     return;
    // }

    const handlePrivacyScroll = () => {
        if (privacyRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = privacyRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                setPrivacyScrolled(true);
            }
        }
    };


    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            {/* 모달 창이 화면을 벗어나지 않도록 하고, 스크롤 가능하게 변경 */}
            <div className="bg-white text-black p-6 rounded-lg w-96 max-h-screen overflow-y-auto">
                <h2 className="text-2xl font-bold mb-4">{isLogin ? "로그인" : "회원가입"}</h2>

                {/* <input
                    type="text"
                    name="username"
                    placeholder="사용자 ID"
                    value={formData.username}
                    onChange={handleInputChange}
                    className="w-full p-2 border mb-2"
                /> */}

                <input
                    type="email"
                    name="email"
                    placeholder="이메일(필수)"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full p-2 border mb-2"
                />

                <div className="relative">
                    <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="비밀번호(필수)"
                        value={formData.password}
                        onChange={handleInputChange}
                        className="w-full p-2 border mb-2 pr-10"
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-3 text-gray-600"
                    >
                        {showPassword ? "🙈" : "👁️"}
                    </button>
                </div>
                
                

                {!isLogin && (
                    <>
                    {/* 회원가입 시 비밀번호 확인 필드 추가 */}
                        <div className="relative">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                name="confirmPassword"
                                placeholder="비밀번호 확인(필수)"
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                className="w-full p-2 border mb-2 pr-10"
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className="absolute right-3 top-3 text-gray-600"
                            >
                                {showConfirmPassword ? "🙈" : "👁️"}
                            </button>
                        </div>

                        {/* <input
                            type="email"
                            name="email"
                            placeholder="이메일"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="w-full p-2 border mb-2"
                        /> */}
                        <input
                            type="text"
                            name="phone"
                            placeholder="전화번호 (예: 01012345678, 비필수)"
                            value={formData.phone}
                            onChange={handleInputChange}
                            onBlur={() => setFormData({ ...formData, phone: formatPhoneNumber(formData.phone) })}

                            className="w-full p-2 border mb-2"
                        />

                        <input
                            type="text"
                            name="name"
                            placeholder="이름(비필수)"
                            value={formData.name}
                            onChange={handleInputChange}
                            className="w-full p-2 border mb-4"
                        />

                        {/* 이용약관 안내 */}
                        {/* <div className="border p-3 rounded bg-gray-100 max-h-32 overflow-y-scroll text-sm mb-2"> */}
                        <div ref={termsRef} onScroll={handleTermsScroll} className="border p-3 rounded bg-gray-100 max-h-40 overflow-y-scroll text-sm mb-2">

                            <h3 className="font-bold mb-1">이용약관</h3>
                            <pre className="whitespace-pre-wrap">{TERMS_OF_SERVICE}</pre>

                        </div>
                        <div className="flex items-center mb-4">
                            <input
                                type="checkbox"
                                checked={termsAccepted}
                                onChange={() => setTermsAccepted(!termsAccepted)}
                                className="mr-2"
                            />
                            <label className="text-sm">이용약관을 확인하였으며, 동의합니다.</label>

                        </div>

                        {/* 개인정보 수집 및 이용 안내 */}
                        <div ref={privacyRef} onScroll={handlePrivacyScroll} className="border p-3 rounded bg-gray-100 max-h-40 overflow-y-scroll text-sm mb-2">

                            <h3 className="font-bold mt-2 mb-1">개인정보 수집 및 이용</h3>

                            <pre className="whitespace-pre-wrap">{PRIVACY_POLICY}</pre>

                        </div>
                        <div className="flex items-center mb-4">
                            <input
                                type="checkbox"
                                checked={privacyAccepted}
                                // disabled={!privacyScrolled}

                                onChange={() => setPrivacyAccepted(!privacyAccepted)}
                                className="mr-2"
                            />
                            <label className="text-sm">개인정보 수집 및 이용에 동의합니다.</label>

                        </div>
                    </>
                )}

                {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
                {successMessage && <p className="text-green-500 text-sm mb-2">{successMessage}</p>}

                <button
                    className={`w-full py-2 mb-2 ${
                        isLogin
                            ? "bg-blue-500 text-white"
                            : termsAccepted && privacyAccepted
                            ? "bg-blue-500 text-white"
                            : "bg-gray-300 text-gray-500"
                    }`}
                    onClick={isLogin ? handleSignIn : handleSignUp}
                    disabled={!isLogin && (!termsAccepted || !privacyAccepted)} // 둘 다 체크해야 버튼 활성화
                >
                    {isLogin ? "로그인" : "회원가입"}
                </button>

                <button onClick={handleAuthToggle} className="text-sm text-blue-500">
                    {isLogin ? "회원가입 하러가기" : "로그인 하러가기"}
                </button>

                <button onClick={onClose} className="block w-full mt-4 text-center text-gray-600">
                    닫기
                </button>
            </div>
        </div>
    );
};

export default AuthModal;